import React from "react";
import axios from "axios";
import { ChakraProvider, Box, Button, theme } from "@chakra-ui/react";

function App() {
  const sendEmail = () => {
    axios
      .post("http://localhost:5500/mailer/sendmail", {
        // Ajoutez ici des données supplémentaires si nécessaire
      })
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <ChakraProvider theme={theme}>
      <Box
        p={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh">
        <Button colorScheme="blue" onClick={sendEmail}>
          Envoyer Email
        </Button>
      </Box>
    </ChakraProvider>
  );
}

export default App;
